import { FC } from "react";
import { CompleteStep } from "pages/UploadCSV/UploadCSVRequirements/steps/CompleteStep";
import { MainLayoutContainer } from "components/Layout";
import { StepsLayoutContainerControlled } from "components/Layout/StepsLayoutContainerControlled";
import { ImportMode } from "pages/UploadCSV/UploadCSVRequirements/types";
import {
  FRAMEWORK_STEP_LABELS,
  FRAMEWORK_STEPS,
  useImportFrameworkSpreadsheet,
} from "./useImportFrameworkSpreadsheet";
import { FrameworkUploadStep } from "./steps/FrameworkUploadStep";
import { FrameworkReviewStep } from "./steps/FrameworkReviewStep";

type Props = {
  mode: ImportMode;
};

export const ImportFrameworkSpreadsheet: FC<Props> = ({ mode }) => {
  const {
    step,
    activeLabel,
    framework,
    uploadError,
    loading,
    reviewLoading,
    reviewError,
    aiReview,
    importBlocked,
    blockingMessages,
    loadingProgress,
    report,
    organizationName,
    setStep,
    handleFile,
    handleAiReview,
    handleApplyAiSuggestions,
    onSubmit,
    handleFinish,
    handleCancel,
  } = useImportFrameworkSpreadsheet({ mode });

  const title =
    mode === "org"
      ? `Import framework spreadsheet${
          organizationName ? ` — ${organizationName}` : ""
        }`
      : "Import framework spreadsheet (Global Catalog)";

  const stepComponentList = [
    {
      label: FRAMEWORK_STEPS.UPLOAD,
      component: (
        <FrameworkUploadStep
          framework={framework}
          error={uploadError}
          loading={loading}
          onFileUploaded={handleFile}
          onNext={() => setStep(FRAMEWORK_STEPS.REVIEW)}
          onCancel={handleCancel}
        />
      ),
    },
    {
      label: FRAMEWORK_STEPS.REVIEW,
      component: framework ? (
        <FrameworkReviewStep
          framework={framework}
          loading={loading}
          reviewLoading={reviewLoading}
          reviewError={reviewError}
          aiReview={aiReview}
          importBlocked={importBlocked}
          blockingMessages={blockingMessages}
          loadingProgress={loadingProgress}
          onBack={() => setStep(FRAMEWORK_STEPS.UPLOAD)}
          onSubmit={onSubmit}
          onAiReview={handleAiReview}
          onApplyAiSuggestions={handleApplyAiSuggestions}
        />
      ) : (
        <FrameworkUploadStep
          framework={null}
          error="Upload a spreadsheet first."
          loading={false}
          onFileUploaded={handleFile}
          onNext={() => undefined}
          onCancel={handleCancel}
        />
      ),
    },
    {
      label: FRAMEWORK_STEPS.COMPLETE,
      component: <CompleteStep report={report} onFinish={handleFinish} />,
    },
  ];

  return (
    <MainLayoutContainer title={title} maxWidth={1200}>
      <StepsLayoutContainerControlled
        steps={FRAMEWORK_STEP_LABELS}
        StepComponentList={stepComponentList}
        activeStep={step}
        activeLabel={activeLabel}
      />
    </MainLayoutContainer>
  );
};
